<template>
  <section class="checkpoint-section" :style="{ backgroundImage: activityData.images ? (activityData.images.bg ? `url(${activityData.images.bg})` : 'none') : 'none' }">
    <Header :notificationIconClass="`fa-calendar-check`" :playProfileNotification="playProfileNotification" v-if="!hideHeader" />
    <div class="checkpoint-container">
      <div class="checkpoint-title" v-html="title"></div>
      <div class="checkpoint-qrCodeReader-wrapper" v-show="found === null" :style="{ height: found === null ? '400px' : '0' }">
        <QRCodeReader class="checkpoint-qrCodeReader" @decode="qrDecoded" v-show="checkPointConfig.useQRCodereader" />
      </div>
      <div class="checkpoint-inputs" v-if="found == null">
        <div class="checkpoint-fields-container" v-if="checkPointConfig.checkType == 'Email'">
          <div class="checkpoint-field-wrapper">
            <ion-icon class="ionicon-icon" name="mail-outline"></ion-icon>
            <input class="checkpoint-field" type="text" v-model="enteredData" :placeholder="placeholder ? placeholder : 'E-mail'" />
          </div>
        </div>
        <div class="checkpoint-fields-container" v-if="checkPointConfig.checkType == 'CPF'">
          <div class="checkpoint-field-wrapper">
            <ion-icon class="ionicon-icon" name="card-outline"></ion-icon>
            <input class="checkpoint-field" type="text" v-maska="['###.###.###-##', '##.###.###/####-##']" placeholder="CPF" @keyup.enter="checkpoint" v-model="enteredData" />
          </div>
        </div>
        <div class="checkpoint-fields-container" v-if="checkPointConfig.checkType == 'Code'">
          <div class="checkpoint-field-wrapper">
            <ion-icon class="ionicon-icon" name="card-outline"></ion-icon>
            <input class="checkpoint-field" type="text" v-model="enteredData" :placeholder="placeholder ? placeholder : 'CODE'" />
          </div>
        </div>
        <input class="checkpoint-button" type="button" :value="cta ? cta : 'CHECK'" @click.prevent="checkpoint" v-if="enteredData" />
      </div>
      <div class="checkpoint-results" v-if="found != null">
        <div class="checkpoint-fields-container" v-if="found == false">
          <div class="checkpoint-field-wrapper">
            <label class="userProfile-inputs-label" for="name">NÃO ENCONTRADO</label>
          </div>
        </div>
        <div class="checkpoint-fields-container" v-if="found == true">
          <!-- COUNTED VALID -->
          <div v-if="!countedValid" class="invalid-overlay">🚫</div>
          <!-- IMAGE -->
          <img class="img-50pc" id="name" type="field" :src="user.image" v-if="checkPointConfig.showImage" />
          <!-- NAME -->
          <div class="checkpoint-field-wrapper" v-if="checkPointConfig.showName">
            <label class="checkpoint-inputs-label" for="name">Nome</label>
            <input disabled="true" class="checkpoint-field-input" id="name" type="field" v-model="user.name" />
          </div>
          <!-- EMAIL -->
          <div class="checkpoint-field-wrapper" v-if="checkPointConfig.showEmail">
            <label class="checkpoint-inputs-label" for="name">Email</label>
            <input disabled="true" class="checkpoint-field-input" id="name" type="field" v-model="user.email" />
          </div>
          <!-- CPF -->
          <div class="checkpoint-field-wrapper" v-if="checkPointConfig.showCPF && user.cpf">
            <label class="checkpoint-inputs-label" for="name">CPF</label>
            <input disabled="true" class="checkpoint-field-input" id="name" type="field" v-model="user.cpf" />
          </div>
          <!-- GAMIFICATION SCORE -->
          <div class="checkpoint-field-wrapper" v-if="checkPointConfig.showGamificationScore && userPoints">
            <label class="checkpoint-inputs-label" for="name">Gamificação</label>
            <label class="checkpoint-field-input">{{ userRank }} lugar - {{ userPoints }} pontos</label>
          </div>
          <!-- LAST CHECKS — oculto quando checkall estiver ativo -->
          <template v-if="!checkPointConfig.checkall">
            <label class="checkpoint-inputs-label last-checkins-label" v-if="checkPointConfig.showLastLogins && userCheckins && userCheckins.length">Últimos checkins [{{ userCheckins.length }}]:</label>
            <div class="checkpoint-field-wrapper last-checkins-wrapper" v-if="checkPointConfig.showLastLogins && userCheckins && userCheckins.length">
              <div class="last-checkins-item" v-for="check in userCheckins" :key="check.checkpoint_id">
                <i class="fas fa-check"></i>
                <label class="checkpoint-field-input last-checkins-input">
                  {{ new Date(check.created_at).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }) }}
                </label>
              </div>
            </div>
          </template>
          <!-- ALL CHECKS SUMMARY -->
          <template v-if="checkPointConfig.checkall && allChecksData.length">
            <label class="checkpoint-inputs-label last-checkins-label">Todos os checks:</label>
            <div class="all-checks-wrapper">
              <div class="all-checks-item" v-for="check in allChecksData" :key="check.uuid">
                <i v-if="check.count > 0" class="fas fa-check all-checks-icon all-checks-icon--ok"></i>
                <i v-else class="fas fa-times all-checks-icon all-checks-icon--fail"></i>
                <span class="all-checks-label">
                  {{ check.label || check.uuid }}
                  <span v-if="check.count > 0" class="all-checks-count">({{ check.count }})</span>
                </span>
                <span class="all-checks-last" v-if="check.lastCheck">
                  {{ new Date(check.lastCheck).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }) }}
                </span>
              </div>
            </div>
          </template>
        </div>
        <!-- RESET BTN -->
        <div class="checkpoint-field-wrapper">
          <input class="checkpoint-button" type="button" value="OK" @click.prevent="eraseUser" />
        </div>
      </div>
    </div>
    <!-- <div class="checkpoint-footer-wrapper">
      <Footer />
    </div> -->
    <Spinner class="checkpoint-spinner-container" :showSpinner="showSpinner" />
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import api from '../services/api';
import { maska } from 'maska';
import QRCodeReader from '@/components/general/QRCodeReader.vue';
import Spinner from '@/components/ui/Spinner.vue';

export default {
  name: 'CheckPointView',
  components: {
    Header,
    Footer,
    QRCodeReader,
    Spinner,
  },
  directives: {
    maska,
  },
  data() {
    return {
      showSpinner: false,
      title: '',
      cta: null,
      user: null,
      found: null,
      activityData: {},
      enteredData: null,
      hideHeader: false,
      playProfileNotification: false,
      placeholder: null,
      checkPointConfig: {
        checkType: 'CPF',
        placeholder: 'CPF',
        cta: 'CHECK',
        useQRCodereader: false,
        showName: true,
        showEmail: true,
        showCPF: true,
        showImage: true,
        showLastLogins: true,
        showGamificationScore: true,
        checkall: false,
        checkall_uuids: [],
      },
      attendees: [],
      leaderboard: [],
      userRank: null,
      userPoints: null,
      tempType: null,
      userCheckins: null,
      countedValid: true,
      allChecksData: [], // [{ uuid, label, count, lastCheck }]
    };
  },

  methods: {
    loadActivity() {
      api
        .get(`activity/${this.$route.params.stream}`)
        .then((response) => {
          let tempImages = { ...this.activityData.images };
          this.activityData = { ...this.activityData, ...response.data };
          this.activityData.images = response.data.images ? JSON.parse(response.data.images) : tempImages;

          let tempProperty = { ...this.activityData.property };
          this.activityData.property = response.data.property ? JSON.parse(response.data.property) : tempProperty;

          this.title = this.activityData.property.sectionTitle ? this.activityData.property.sectionTitle : this.activityData.description_short;
          this.hideHeader = this.activityData.property.hideHeader ? this.activityData.property.hideHeader : false;

          this.checkPointConfig = this.activityData.property.checkPointConfig ? this.activityData.property.checkPointConfig : this.checkPointConfig;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    eraseUser() {
      this.user = null;
      this.found = null;
      this.userRank = null;
      this.userPoints = null;
      this.enteredData = null;
      this.userCheckins = null;
      this.allChecksData = [];
    },

    buildCheckObj() {
      const type = this.checkPointConfig.checkType;
      if (type === 'ID') return { user_id: this.enteredData };
      if (type === 'Email') return { email: this.enteredData };
      if (type === 'Code') return { code: this.enteredData };
      return { cpf: this.enteredData };
    },

    checkpoint() {
      this.showSpinner = true;

      let obj = null;
      let key = null;

      if (this.enteredData) {
        if (this.checkPointConfig.checkType == 'ID') {
          obj = { user_id: this.enteredData };
          key = 'user_id';
          this.checkPointConfig.checkType = this.tempType;
        } else if (this.checkPointConfig.checkType == 'Email') {
          obj = { email: this.enteredData };
          key = 'email';
        } else if (this.checkPointConfig.checkType == 'CPF') {
          obj = { cpf: this.enteredData };
          key = 'cpf';
        } else if (this.checkPointConfig.checkType == 'Code') {
          obj = { code: this.enteredData };
          key = 'code';
        } else {
          return false;
        }
      } else {
        return false;
      }

      this.countedValid = true;

      api
        .post(`event/${this.$store.state.eventId}/checkPoint/${this.$route.params.stream}`, obj)
        .then((response) => {
          this.user = response.data;
          this.userCheckins = response.data.checks;
          this.found = true;

          if (this.checkPointConfig.countValid) {
            this.countedValid = this.checkPointConfig.countValid > this.userCheckins.length;
          }

          // Encadeia o fluxo: checkall → filteredUserData → gamification
          if (this.checkPointConfig.checkall) {
            this.getAllChecksData().then(() => {
              if (this.checkPointConfig.showCPF) {
                this.getFilteredUserData(key, this.enteredData);
              } else {
                this.showSpinner = false;
              }
            });
          } else if (this.checkPointConfig.showCPF) {
            this.getFilteredUserData(key, this.enteredData);
          } else {
            this.showSpinner = false;
          }
        })
        .catch((error) => {
          console.error(error);
          this.showSpinner = false;
          this.eraseUser();
        });
    },

    qrDecoded(data) {
      this.enteredData = data.id;
      this.tempType = this.checkPointConfig.checkType;
      this.checkPointConfig.checkType = 'ID';
      this.checkpoint();
    },

    async getAllChecksData() {
      const uuids = this.checkPointConfig.checkall_uuids || [];
      const currentUuid = this.$route.params.stream;

      // Garante que o próprio uuid está na lista (sem duplicatas)
      const allUuids = [...new Set([currentUuid, ...uuids])];

      const results = await Promise.all(
        allUuids.map(async (uuid) => {
          // Busca nome da atividade para exibir no lugar do uuid
          let activityLabel = null;
          try {
            const actRes = await api.get(`activity/${uuid}`);
            const prop = actRes.data.property ? JSON.parse(actRes.data.property) : {};
            activityLabel = prop.sectionTitle || actRes.data.description || actRes.data.description_short || null;
          } catch {
            activityLabel = null;
          }

          // Busca checkins do usuário neste checkpoint
          try {
            const res = await api.get(`event/${this.$store.state.eventId}/checkPoint/${uuid}/${this.enteredData}`);
            const checks = res.data.checks || [];
            const sorted = [...checks].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
            return {
              uuid,
              label: activityLabel,
              count: checks.length,
              lastCheck: sorted.length ? sorted[0].created_at : null,
            };
          } catch {
            return {
              uuid,
              label: activityLabel,
              count: 0,
              lastCheck: null,
            };
          }
        }),
      );

      this.allChecksData = results;
    },

    getFilteredUserData(key, value) {
      this.showSpinner = true;
      api
        .get(`event/${this.$store.state.eventId}/usersAll?&field[]=${key}&valueArr[]=${value}&limit=${100}`)
        .then((response) => {
          this.attendees = response.data;
          if (this.attendees.length) this.user = this.attendees[0];
          this.enteredData = null;
          if (this.checkPointConfig.showGamificationScore) {
            this.getGamififactionRanking();
          } else {
            this.showSpinner = false;
          }
        })
        .catch((err) => {
          console.warn("Field not on user root, trying in 'other'", err);
          api
            .get(`event/${this.$store.state.eventId}/usersAll?&field[]=other&valueArr[]=${value}&limit=${100}`)
            .then((response) => {
              this.attendees = response.data.map((user) => this.flattenUserProperties(user));
            })
            .catch((err) => {
              this.showSpinner = false;
              console.error(err);
            });
        });
    },

    flattenUserProperties(user) {
      let flattenedUser = {};
      try {
        flattenedUser.other = JSON.parse(user.other);
        flattenedUser = { ...user, ...flattenedUser.other };
      } catch (err) {
        flattenedUser.other = {};
      }
      return flattenedUser;
    },

    getGamififactionRanking() {
      api
        .get(`event/${this.$store.state.eventId}/gamificationRanking`)
        .then((response) => {
          this.leaderboard = response.data;
          this.leaderboard.map((user, i) => {
            i++;
            if (user.user_id == this.user.user_id) {
              if (user.points) this.userPoints = user.points;
              this.userRank = `${i}º`;
              if (i > 50) this.userRank = `50+`;
            }
            user.name = user.nickname ? user.nickname : user.name ? user.name : user.email ? user.email.split('@')[0] : 'Anônimo';
          });
          this.showSpinner = false;
        })
        .catch((err) => {
          this.showSpinner = false;
          console.error(err);
        });
    },
  },

  beforeMount() {
    this.loadActivity();
  },
};
</script>

<style lang="scss">
.checkpoint-section {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100dvh;
  background-color: var(--main-color);
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: no-repeat;
  overflow-y: auto;
  user-select: none;

  display: flex;
  flex-direction: column;
}
.checkpoint-title {
  position: relative;
  margin: 40px 0 0;
  font-size: 2rem;
  text-align: center;
  color: whitesmoke;
  z-index: 1;
}
.checkpoint-container {
  position: relative;
  margin: auto auto 80px auto;
  width: 100%;
  max-width: 400px;
  height: 100%;
  max-height: 90vh;
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &::-webkit-scrollbar {
    width: 12px;
    @include media('<=tablet') {
      width: 0;
    }
  }
  &::-webkit-scrollbar-track {
    background-color: rgb(70, 69, 66);
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(102, 102, 102) !important;
    border-radius: 4px;
    background-image: none !important;
  }
}

.checkpoint-qrCodeReader-wrapper {
  position: relative;
  width: 100%;
  max-width: 400px;
  height: 420px;

  .checkpoint-qrCodeReader {
    position: relative !important;
    width: 100% !important;
    height: 100% !important;
    max-width: 400px !important;

    .qr-inner-box {
      margin-top: 10px !important;
      width: 94% !important;
      height: 94% !important;
    }

    .qr-overlay-label {
      top: 20px !important;
    }
  }
}

.checkpoint-results {
  position: relative;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: flex-start;
}

.checkpoint-fields-container {
  position: relative;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;

  img {
    margin-bottom: 20px;
    border-radius: 50%;
  }
}

.checkpoint-footer-wrapper {
  position: relative;
  margin-top: auto;
  z-index: 10;
}

.checkpoint-field-wrapper {
  position: relative;
  height: 40px;
  width: 100%;
  padding: 0 20px;

  display: flex;
  align-items: center;
}

.checkpoint-field {
  position: relative;
  padding: 0 10px;
  width: 100%;
  border: 0;
  outline: none;
  color: var(--input-text);
  background-color: transparent;
  &::placeholder {
    color: var(--input-text);
    opacity: 0.8;
  }
}

.checkpoint-field-input {
  position: relative;
  padding: 0 10px;
  width: 100%;
  border: 0;
  outline: none;
  color: var(--text-color, #000);
  background-color: transparent;
  &::placeholder {
    color: var(--text-color, #000);
    opacity: 0.8;
  }
}

.checkpoint-inputs-label {
  position: relative;
  width: 140px;
  font-size: 0.9rem;
  opacity: 0.8;
}

.checkpoint-button {
  position: relative;
  margin-top: 16px;
  padding: 10px 14px;
  width: 100%;
  color: var(--button-text);
  background-color: var(--button-background);
  border-radius: var(--input-borderRadius) !important;
  border: 1px solid var(--button-outline);
  font-weight: bold;
  letter-spacing: 0.1rem;
  cursor: pointer;
  outline: none;
}

.checkpoint-spinner-container {
  background: #252525de !important;

  .lds-spinner {
    position: absolute;
    top: 45%;
  }
}

.last-checkins-label {
  position: relative;
  margin: 10px 0 0 40px;
  width: 100%;
  text-align: left;
}
.last-checkins-wrapper {
  position: relative;
  margin-top: 10px;
  height: auto;
  max-height: 110px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0;

  .last-checkins-item {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;

    i {
      color: #00ff00;
      font-size: 20px;
    }

    .last-checkins-input {
      position: relative;
      width: auto;
      text-align: center;
      font-size: 0.8rem;
    }
  }
}

.invalid-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 200px;
  z-index: 20;
  opacity: 0.9;
  pointer-events: none;
}

// ALL CHECKS
.all-checks-wrapper {
  position: relative;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  padding: 4px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.all-checks-item {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.82rem;
  color: var(--text-color, #fff);

  .all-checks-icon {
    font-size: 14px;
    min-width: 14px;

    &--ok {
      color: #00ff00;
    }
    &--fail {
      color: #ff4444;
    }
  }

  .all-checks-label {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .all-checks-count {
      opacity: 0.9;
      font-weight: bold;
      margin-left: 2px;
    }
  }

  .all-checks-last {
    opacity: 0.7;
    white-space: nowrap;
    flex-shrink: 0;
  }
}
</style>
